import mutationTypes from './mutation-types'

export default {
  [mutationTypes.SET_TOTAL_PRICE] (state, payload) {
    state.totalPrice = payload
  },
  [mutationTypes.SET_TOTAL_PRICE_FORMATTED] (state, payload) {
    state.totalPriceFormatted = payload
  },
  [mutationTypes.SET_ITEM_PRICE] (state, payload) {
    state.itemPrice = payload
  },
  [mutationTypes.SET_ITEM_PRICE_FORMATTED] (state, payload) {
    state.itemPriceFormatted = payload
  },
  [mutationTypes.SET_TOTAL_PACKAGING_PRICE] (state, payload) {
    state.totalPackagingPrice = payload;
  },
  [mutationTypes.SET_TOTAL_PACKAGING_PRICE_FORMATTED] (state, payload) {
    state.totalPackagingPriceFormatted = payload;
  },
  [mutationTypes.SET_CART_GROUPS] (state, payload) {
    state.cartGroups = payload;
  },
  [mutationTypes.SET_ORDER_DELIVERY_TYPE] (state, payload) {
    state.orderDeliveryType = payload;
  },
  [mutationTypes.SET_ORDER_PAYMENT_TYPES] (state, payload) {
    state.orderPaymentTypes = payload;
  },
  [mutationTypes.SET_ORDER_PAYMENT_TYPE] (state, payload) {
    state.orderPaymentType = payload;
  },
  [mutationTypes.SET_UPDATE_CART_URL] (state, payload) {
    state.updateCartUrl = payload;
  },
  [mutationTypes.SET_FIRSTNAME] (state, payload) {
    state.firstname = payload;
  },
  [mutationTypes.SET_LASTNAME] (state, payload) {
    state.lastname = payload;
  },
  [mutationTypes.SET_PHONE] (state, payload) {
    state.phone = payload;
  },
  [mutationTypes.SET_EMAIL] (state, payload) {
    state.email = payload;
  },
  [mutationTypes.SET_ADDRESS] (state, payload) {
    state.address = payload;
  },
  [mutationTypes.SET_ERRORS] (state, errors) {
    for (let key in errors) {
      state.errors[key] = errors[key];
    }
  },
  [mutationTypes.SET_IS_VALID] (state, payload) {
    state.is_valid = payload;
  },
  [mutationTypes.SET_NOTE] (state, payload) {
    state.note = payload;
  },
  [mutationTypes.SET_TOTAL_AMOUNT] (state, payload) {
    state.totalAmount = payload;
  }
}
